import { getMetaTicketOptions } from "../../app/api/getMetaTicketOptions";
import { ITicketOption, ITicketOptionResponse } from "../../Orchestrator/Types/Interface/ITicketOption";

class TicketOptionManager {
  private static instance: TicketOptionManager;
  private options: ITicketOption[] | null = null;
  private optionsMap: Map<string, ITicketOption> = new Map();
  private fetchPromise: Promise<ITicketOption[]> | null = null;

  private constructor() {}

  public static getInstance(): TicketOptionManager {
    if (!TicketOptionManager.instance) {
      TicketOptionManager.instance = new TicketOptionManager();
    }
    return TicketOptionManager.instance;
  }

  /**
   * Fetch ticket options once and cache them in memory.
   */
  public async fetchTicketOptions(): Promise<ITicketOption[]> {
    if (this.options) return this.options;
    if (this.fetchPromise) return this.fetchPromise;

    this.fetchPromise = getMetaTicketOptions(false).then((res) => {
      const opts: ITicketOptionResponse | undefined = res.answer;
      if (res.status === "ok" && Array.isArray(opts)) {
        this.options = opts;
        this.optionsMap = new Map(this.options.map((o) => [o.value, o]));
        return this.options;
      } else {
        this.options = [];
        return this.options;
      }
    });
    return this.fetchPromise;
  }

  /**
   * Returns the ticket option by its value. If not loaded yet, returns fallback.
   */
  public getOptionByValue(value: string): ITicketOption | null {
    if (!this.options) return null;
    return this.optionsMap.get(value) || null;
  }

  /**
   * Returns all cached ticket options (empty array if not yet fetched).
   */
  public getAllOptions(): ITicketOption[] {
    return this.options || [];
  }
}

const ticketOptionManager = TicketOptionManager.getInstance();
export default ticketOptionManager;